export const SERVER_URL = import.meta.env.VITE_LIVEKIT_URL;

export enum ParticipantRole {
  TEACHER = 'teacher',
  ASSISTANT = 'assistant',
  STUDENT = 'student'
  // you can append new roles at the end
}

export enum MeetingMode {
  THEORY,
  PRACTICE
  // you can append new modes at the end
}
